import React from 'react'
import { connect } from 'react-redux'
import { Menu, Dropdown } from 'antd'
import styles from './style.module.scss'
import AuthAPI from 'services/login'
import Common from 'services/common'
// import { Link } from 'react-router-dom'

@connect(({ settings, user }) => ({
  user,
  theme: settings.theme,
  primaryColor: settings.primaryColor,
}))
class ProfileMenu extends React.Component {
  state = {
    count: 7,
    logoutStatus: null,
  }
  authLogout = () => {
    var ssid = localStorage.getItem('SSID')
    let input = {
      SSID: ssid,
    }
    var historyURL = localStorage.getItem('historyURL')
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem('historyURL', historyURL)
    AuthAPI.invalidate({ SSID: ssid, clusterId: this.props.user.selectedCluster.clusterId }).then(
      response => {
        var data = response.data
        if (data.status === 'success') {
          this.setState({ logoutStatus: data.data })
        }
        if (data !== null) {
          this.setState({ logoutStatus: data.data })
        }
      },
    )
    AuthAPI.logout(JSON.stringify(input))
      .then(response => {
        var data = response.data
        if (data.status === 'success') {
          this.setState({ logoutStatus: data.data })
        }
        if (data !== null) {
          this.setState({ logoutStatus: data.data })
        }
      })
      .catch(err => {
        this.setState({ logoutStatus: 'success' })
        var historyURL = localStorage.getItem('historyURL')
        localStorage.clear()
        sessionStorage.clear()
        localStorage.setItem('historyURL', historyURL)
      })
  }

  switchDarkTheme = () => {
    document.getElementById('user-menu').parentNode.classList.add('show-dropdown')
    const { dispatch } = this.props
    dispatch({ type: 'settings/TOGGLE_THEME' })
    setTimeout(() => {
      document.getElementById('user-menu').parentNode.classList.remove('ant-dropdown-hidden')
    }, 300)
  }

  logout = e => {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch({
      type: 'user/SET_STATE',
      payload: {
        id: '',
        name: '',
        role: '',
        email: '',
        avatar: '',
        authorized: false,
        licenseType: '',
        loading: false,
        eulaStatus: false,
      },
    })
    localStorage.removeItem('payload')
    localStorage.removeItem('historyURL')
    // localStorage.setItem('historyURL','null')
    dispatch({
      type: 'user/LOGOUT',
      payload: {
        ssid: localStorage.getItem('SSID'),
        clusterId: this.props.user.selectedCluster.clusterId,
      },
    })
  }

  addCount = () => {
    let { count } = this.state
    count += 1
    this.setState({
      count,
    })
  }

  componentDidUpdate() {
    // if (this.props.theme === 'light') {
    //   this.switchDarkTheme()
    // }
  }

  render() {
    var cluster_id = window.location.hash.replace('#/', '').split('/')[0]
    var scope_id = ''
    if (typeof window.location.hash.replace('#/', '').split('/')[1] !== 'undefined') {
      if (window.location.hash.replace('#/', '').split('/')[1] !== 'admin') {
        scope_id = '/' + window.location.hash.replace('#/', '').split('/')[1]
      }
    }
    var email = Common.decryptData(localStorage.getItem('email'), true)
    const menu = (
      <Menu selectable={false} id="user-menu">
        <Menu.Item>
          <div>
            <strong>User</strong>
            <br />
            {email}
          </div>
        </Menu.Item>
        <Menu.Divider />

        <Menu.Item>
          <div onClick={this.logout}>
            <i className="fal fa-sign-out mr-2"></i>
            Logout
          </div>
        </Menu.Item>
      </Menu>
    )
    return (
      <Dropdown
        overlay={menu}
        trigger={['click']}
        onVisibleChange={this.addCount}
        placement="bottomRight"
      >
        <div className={styles.dropdown}>
          <i style={{ fontSize: '1rem' }} className="fal fa-user" />
        </div>
      </Dropdown>
    )
  }
}

export default ProfileMenu
